import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
    const { t } = useTranslation();
    let link = "mailto:info@mi-expert.com?subject=" 
    + encodeURIComponent(t("Request for MiChat Free Trial"))+ "&body="
    + encodeURIComponent(t("Hi MiChat Team,\n\nI would like to request a free trial of MiChat. Please provide me with more information on how I can get started.\n\nThank you."));
    let waLink="https://wa.me/85265554706?text="
    + encodeURIComponent(t("Hi MiChat Team,\n\nI would like to request a free trial of MiChat. Please provide me with more information on how I can get started.\n\nThank you."));
    return (
        <header className="pt-24 pb-16 bg-gradient-to-r from-green-200 to-blue-200">
            <div className="container mx-auto px-6">
                <div className="flex flex-col md:flex-row items-center">
                    <motion.div 
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="md:w-1/2 mb-16 md:mb-0"
                    >
                        <h1 className="text-4xl md:text-4xl font-bold text-gray-900 mb-6">
                            {t("Transform Your Customer Service with AI")}
                        </h1>
                        <p className="text-xl text-gray-700 mb-8">
                            {t("Create your own AI chatbot in minutes. Perfect for small and medium businesses looking to provide 24/7 customer support.")}
                        </p>
                        <a href={waLink}>
                        <button className="bg-blue-500 text-white px-8 py-3 rounded-full text-lg hover:bg-blue-600 transition duration-300 shadow-lg">
                            {t("Start Free Trial")}
                        </button>
                        </a>
                    </motion.div>
                    <motion.div 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="md:w-1/2"
                    >
                        <motion.div 
                            animate={{ y: [0, -20, 0] }}
                            transition={{ duration: 6, repeat: Infinity }}
                            className="bg-white p-6 rounded-lg shadow-2xl"
                        >
                            <div className="flex items-center mb-4">
                                <div className="w-3 h-3 bg-red-500 rounded-full mr-2"></div>
                                <div className="w-3 h-3 bg-yellow-500 rounded-full mr-2"></div>
                                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                            </div>
                            <div className="space-y-4">
                                <div className="flex items-start">
                                    <div className="bg-gray-200 rounded-lg p-3 max-w-xs">
                                        <p>{t("How can I help you today?")}</p>
                                    </div>
                                </div>
                                <div className="flex items-start justify-end">
                                    <div className="bg-blue-500 text-white rounded-lg p-3 max-w-xs">
                                        <p>{t("I need information about your product pricing.")}</p>
                                    </div>
                                </div>
                                <div className="flex items-start">
                                    <div className="bg-gray-200 rounded-lg p-3 max-w-xs">
                                        <p>{t("Our plans start at HKD $7,000 per month. Would you like to know more details?")}</p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
            </div>
        </header>
    );
};

export default HeroSection;
